import { render, staticRenderFns } from "./ShiftPatternOrder.vue?vue&type=template&id=4684828d&scoped=true"
import script from "./ShiftPatternOrder.vue?vue&type=script&lang=js"
export * from "./ShiftPatternOrder.vue?vue&type=script&lang=js"
import style0 from "./ShiftPatternOrder.vue?vue&type=style&index=0&id=4684828d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684828d",
  null
  
)

export default component.exports